import {useGetList} from '../context/useQuery'
import {useStore} from '../hook'
import StoreDetail from './detail'

function Dashboard() {
  const {list} = useStore()
  const {isLoading} = useGetList()

  return (
    <>
      <StoreDetail storeData={list} />
    </>
  )
}

export default Dashboard
